import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { FireblockService } from './fireblockvault.service';
import * as moment from 'moment';
import { MatDatepickerInputEvent, MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
@Component({
    selector: 'app-fireblockvault',
    templateUrl: './fireblockvault.component.html',
    styleUrls: ['./fireblockvault.component.css']
})
export class FireblockVaultComponent implements OnInit {
    displayedColumns = [
        'Action',
        'vault_id', 
        'userEmail', 
        'vault_name', 
        'createdAt',
     ];
    displayedColumnsVaultId = [
        'transferAction', 
        'vaultId', 'id', 
        'name', 
        'available', 
        'balance', 
        'total', 
        'pending', 
        'frozen', 
        'lockedAmount', 
        'blockHeight', 
        'staked', 
        'customerRefId',
    ];
    displayedColumnsCwallets = [
        'currency', 
        'availableBalance',
        'balance'        
    ];

    public dataSource: any = new MatTableDataSource();
    public dataSource2: any = new MatTableDataSource();
    public dataSourceCwallets: any = new MatTableDataSource();
    @ViewChild('paginator', { read: MatPaginator }) paginator: MatPaginator;
    @ViewChild('paginator1', { read: MatPaginator }) paginator1: MatPaginator;
    @ViewChild('paginatorCwallets', { read: MatPaginator }) paginatorCwallets: MatPaginator;
    @ViewChild('sort', { read: MatSort }) sort: MatSort;
    @ViewChild('sort1', { read: MatSort }) sort1: MatSort;
    @ViewChild('sortCwallets', { read: MatSort }) sortCwallets: MatSort;
    filter: any = {};
    fromDate;
    toDate;
    isVaultId: any;
    pageSize = 10;
    pageSize1 = 5;
    pageSizeCwallets = 5;
    currentPage = 0;
    currentPage1 = 0;
    vaultId:any;
    currentPageCwallets = 0;
    pageSizeOptions: number[] = [5, 10, 25, 50, 100];
    pageSizeOptions1: number[] = [5, 10, 25, 50, 100];
    pageSizeOptionsCwallets: number[] = [5, 10, 25, 50, 100];
    constructor(private userService: UserService, private fireblockVault: FireblockService) {
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    async pageChanged(event: PageEvent) {
        this.pageSize = await event.pageSize;
        this.currentPage = await event.pageIndex;
    }
    async pageChanged1(event: PageEvent) {
        this.pageSize1 = await event.pageSize;
        this.currentPage1 = await event.pageIndex;
    }

    async pageChangedCwallets(event: PageEvent) {
        this.pageSizeCwallets = await event.pageSize;
        this.currentPageCwallets = await event.pageIndex;
    }

    async applyRefreshData() {
        this.fireblockVault.getFireblockVault().subscribe((success) => {
            success.data.unshift({ vault_id: '0', userEmail: 'adminemail', vault_name: 'adminVault' })
            let res = success.data.map((element) => {
                element.createdAt = element.createdAt ? moment(element.createdAt).format('MM/DD/YY h:mm:ss A') : ''; 
                return element;
            })
            this.dataSource = new MatTableDataSource(res);
            this.dataSource.paginator = this.paginator
            this.dataSource.sort = this.sort;
        })
    }

    async transferFireblocks(vaultId = '',assetId = '') {
        var obj = {
            vaultId: vaultId,
            assetId: assetId,
        }
        if (window.confirm('Are you sure want to transfer Fireblocks balance?')) {
            this.fireblockVault.syncFireblocks(obj).subscribe((success) => {}) 
        }
    }
    async exportArray(data = null) {
        if (this.dataSource.filteredData) {
            const fireblockVault = await this.dataSource.filteredData.map(x => ({
                VaultId: x.vault_id,
                UserEmail: x.userEmail,
                VaultName: x.vault_name,
                CreatedAt: x.createdAt,
            }));
            TableUtil.exportArrayToExcel(fireblockVault, "fireblockVault");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
    ngOnInit() {
        this.csrf();
        // this.dataSource2 = new MatTableDataSource([]);
        this.applyRefreshData();

    }
    getVaultDetails(vaultId: any, userId: any) {
        this.vaultId = vaultId;
        this.isVaultId = true;
        this.userService.getVault(vaultId).subscribe(data => {
            let vaultRes = data.assets.map(vault => {
                vault.vaultId = data.id;
                vault.customerRefId = data.customerRefId;
                vault.name = data.name;
                return vault;
            })
            if (vaultRes) {
                this.dataSource2 = new MatTableDataSource(vaultRes);
                this.dataSource2.paginator = this.paginator1;
                this.dataSource2.sort = this.sort1;
            }
        })
        if(userId && vaultId !== '0') {
            this.userService.getCwalUser(userId).subscribe(Cwallets => {
            let CwalletsRes = Cwallets.wallist.map(wallet => {
                wallet.userid = wallet.userid;
                wallet.currency = wallet.currency;
                wallet.availableBalance = wallet.availableBalance;
                wallet.balance = wallet.balance;
                return wallet;
            })
            if (CwalletsRes && vaultId !== '0') {
                this.dataSourceCwallets = new MatTableDataSource(CwalletsRes);
                this.dataSourceCwallets.paginator = this.paginatorCwallets;
                this.dataSourceCwallets.sort = this.sortCwallets;
            } else {
                this.dataSourceCwallets = new MatTableDataSource([])
            };
        })
        }
    }
    applyFilterCwallets(value){
        value = value.trim(); // Remove whitespace
        value = value.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource2.filter = value;
        this.dataSourceCwallets.filter = value;
    }

}

export interface fireblockData {
    vault_id: string,
    userEmail: string,
    vault_name: string,
    createdAt:string
}


// WEBPACK FOOTER //
// ./src/app/fireblockvault/fireblockvault.component.ts